import { getTranslation } from 'utils/getTranslation';
import * as yup from 'yup';

const t = getTranslation('user.LocationsTable');
export interface IEditOfficeFormSchema {
  id: string;
  name: string;
  idexxAccountNumber?: string | null;
  zoetisAccountNumber?: string | null;
  regionId: string;
}

export const editOfficeFormSchema: yup.SchemaOf<IEditOfficeFormSchema> =
  yup.object({
    id: yup.string().required(),
    name: yup
      .string()
      .max(100, t('lessThan', { max: 100 }))
      .strict(true)
      .trim(t('mustBeTrimmed'))
      .required(t('officeNameIsRequired')),
    idexxAccountNumber: yup
      .string()
      .max(100, t('lessThan', { max: 100 }))
      .optional()
      .nullable()
      .trim(t('mustBeTrimmed')),
    zoetisAccountNumber: yup
      .string()
      .max(100, t('lessThan', { max: 100 }))
      .optional()
      .nullable()
      .trim(t('mustBeTrimmed')),
    regionId: yup.string().required(t('regionIsRequired')),
  });
